import { fetchInterceptor } from '../commons/Interceptor'
import { getBaseURL, getToken } from '../environment'

const newBaseURL = `${getBaseURL()}/products`

export const getAllMeasurementUnits = () => {
    return fetchInterceptor(`${newBaseURL}/measurementUnits`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    })
        .then(response => response.json())
        .catch(error => {
            console.error('Erro: ' + JSON.stringify(error))
            throw error
        })
}
